import notification from '@/mixins/notification.js'
export default {
  mixins: [notification],
  methods: {
    getBankName (withdrawalMethod) {
      return (
        withdrawalMethod?.details?.bankDetails?.bankName ||
        withdrawalMethod?.details?.bankWithdrawalDetails?.bankName
      )
    },
    getWalletAddress (withdrawalMethod) {
      return (
        withdrawalMethod?.details?.walletAddress ||
        withdrawalMethod?.details?.walletDetails?.walletAddress
      )
    },
    getAssetName (withdrawalMethod) {
      return (
        withdrawalMethod?.details?.assetName ||
        withdrawalMethod?.details?.walletDetails?.assetType
      )
    },
    getAccountLabel (withdrawalMethod) {
      const isMobileMoney =
        withdrawalMethod?.details?.bankDetails?.isMobileMoney === 'yes' ||
        withdrawalMethod?.details?.bankWithdrawalDetails?.isMobileMoney ===
          'yes'
      return isMobileMoney ? 'Phone Number' : 'Account Number'
    },
    getAccountNumber (withdrawalMethod) {
      return (
        withdrawalMethod?.details?.bankDetails?.accountNumber ||
        withdrawalMethod?.details?.bankWithdrawalDetails?.accountNumber
      )
    },
    getAccountName (withdrawalMethod) {
      return (
        withdrawalMethod?.details?.bankDetails?.accountName ||
        withdrawalMethod?.details?.bankWithdrawalDetails?.accountName
      )
    },
    getCurrency (withdrawalMethod) {
      return withdrawalMethod.currency
    },
    async getWithdrawalMethods () {
      this.isLoading = true
      await this.$store
        .dispatch('withdrawal/getWithdrawalMethods')
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          this.handleErrorResponseNotification(error)
        })
    },
    createWithdrawalMethod (twoFaCode) {
      const beneficiaryDetails = this.withdrawalDetails.beneficiaryDetails
      if (beneficiaryDetails.walletDetails) {
        this.meta = {
          twoFaCode: twoFaCode.code,
          type: this.$transactionType.ASSET_TRANSFER,
          beneficiaryDetails: beneficiaryDetails
        }
      } else {
        this.meta = {
          twoFaCode: twoFaCode.code,
          type: this.$transactionType.BANK_TRANSFER,
          destinationCurrency: beneficiaryDetails?.bankDetails?.currency,
          beneficiaryDetails: beneficiaryDetails
        }
      }
      const vm = this
      this.$store
        .dispatch('withdrawal/createWithdrawalMethod', { ...this.meta })
        .then(() => {
          this.showVerifyAuthDialog = false
          this.$notify({
            title: 'Success',
            message: 'Account Added',
            type: 'success'
          })
          this.getWithdrawalMethods()
          this.getAllNotifications()
        })
        .catch((error) => {
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {
          this.showVerifyAuthDialog = false
        })
    }
  }
}
